import { newSpecPage } from '@stencil/core/testing';
import { NylasEventDuration } from '../nylas-event-duration';
import { InputDropdown } from '../../../design-system/input-dropdown/input-dropdown';
import { h } from '@stencil/core';
import { SelectDropdown } from '../../../design-system/select-dropdown/select-dropdown';
import { selectedConfiguration } from '@/utils/test-utils';

describe('nylas-event-duration', () => {
  const config = {
    ...selectedConfiguration,
    availability: {
      ...selectedConfiguration.availability,
      duration_minutes: 60,
    },
  };
  let page: any;
  let eventDuration: NylasEventDuration;
  beforeEach(async () => {
    page = await newSpecPage({
      components: [InputDropdown, SelectDropdown, NylasEventDuration],
      template: () => {
        return <nylas-event-duration name="eventDuration" selectedConfiguration={config} />;
      },
    });
    await page.waitForChanges();
    eventDuration = page.rootInstance;
  });

  it('shows error when duration is not a multiple of 5 or if duration is empty', async () => {
    const newConfig = {
      ...config,
      availability: {
        ...config.availability,
        duration_minutes: 18,
      },
    };
    page.root.selectedConfiguration = newConfig;
    await page.waitForChanges();

    const customEvent = new CustomEvent('inputOptionChanged', {
      detail: { value: 18, name: 'eventDuration' },
    });
    eventDuration.inputOptionChangedHandler(customEvent);
    await page.waitForChanges();
    expect(page.root).toMatchSnapshot();
    const error = page.root.shadowRoot.querySelector('.nylas-event-duration__error');
    expect(error).not.toBeNull();
    expect(error.textContent).toBe('Duration must be a multiple of 5');

    await page.waitForChanges();

    const customEvent2 = new CustomEvent('inputOptionChanged', {
      detail: { value: 0, name: 'eventDuration' },
    });
    eventDuration.inputOptionChangedHandler(customEvent2);
    await page.waitForChanges();
    expect(page.root).toMatchSnapshot();
    const error2 = page.root.shadowRoot.querySelector('.nylas-event-duration__error');
    expect(error2).not.toBeNull();
    expect(error2.textContent).toBe('Duration must be greater than 0');
  });
});
